import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import Structure from './structure';
import reportWebVitals from './reportWebVitals';
import sw from '../package.json';

// css
import './index.css';
import 'gui-com-lib/src/ui/assets/iconset/style.css';
import 'gui-com-lib/dist/style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';

// translation
import './i18n';

console.info(`${sw.name} version ${sw.version}`);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <Structure />
    </React.StrictMode>
  </BrowserRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
